// 수업 관리 목록·이력 탭이 같이 쓰는 상수

export const CLASS_TYPE_OPTIONS = [
  { value: '', label: '전체' },
  { value: 'PRIVATE_LESSON', label: '개인레슨' },
  { value: 'DUET_LESSON', label: '듀엣레슨' },
  { value: 'GROUP_LESSON', label: '그룹레슨' },
  { value: 'OT', label: 'OT' },
  // 온라인 레슨 숨김 (2026-10-16)
  // { value: 'ONLINE_LESSON', label: '온라인레슨' },
];

// 날짜 입력: 기본 폭이 넓어 달력 아이콘 오른쪽이 빈다. 내용 폭에 맞추고 좌우 여백을 14px 로 같게
export const dateFieldSx = { width: 'fit-content', '& .MuiInputBase-input': { px: '14px', width: 'auto' } };

export const SEARCH_FIELDS = [
  { value: 'member', label: '회원', placeholder: '이름 또는 연락처' },
  { value: 'className', label: '수업명', placeholder: '수업명' },
];

// 조회: 옆 입력칸과 같은 높이(40px)·테두리 모양, 검은 글자
export const searchButtonSx = {
  height: 40, minWidth: 72, px: 2, borderRadius: '4px', fontSize: '14px', fontWeight: 600,
  color: '#262626', borderColor: 'rgba(0, 0, 0, 0.23)', background: '#fff',
  '&:hover': { borderColor: '#262626', background: '#F5F5F5' },
};

export const headCellSx = { fontWeight: 600, whiteSpace: 'nowrap', background: '#F7F9FA' };

export const bodyCellSx = { whiteSpace: 'nowrap' };
